import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=b967de68&scoped=true"
import script from "./Integral.vue?vue&type=script&lang=js"
export * from "./Integral.vue?vue&type=script&lang=js"
import style0 from "./Integral.vue?vue&type=style&index=0&id=b967de68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b967de68",
  null
  
)

export default component.exports